// extracted by mini-css-extract-plugin
export default {"warningImgBox":"styles_warningImgBox__9OHh8","warningImg":"styles_warningImg__cMhrp"};